
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import TopNavigation from '../../components/feature/TopNavigation';
import BottomNavigation from '../../components/feature/BottomNavigation';

export default function ProfilePage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
  const [notifications, setNotifications] = useState(true);

  const userInfo = {
    name: 'أحمد محمد السعيد',
    phone: '+966 50 123 4567',
    email: 'ahmed@example.com',
    city: 'الرياض',
    joinDate: '2023',
    totalTrips: 45,
    rating: 4.8
  };

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === 'ar' ? 'en' : 'ar');
  };

  const handleLogout = () => {
    // Simulate logout
    navigate('/auth');
  };

  const menuItems = [
    {
      id: 'edit-profile',
      title: t('editProfile'),
      icon: 'ri-edit-line',
      action: () => navigate('/profile/edit')
    },
    {
      id: 'trip-history',
      title: t('tripHistory'),
      icon: 'ri-history-line',
      action: () => navigate('/orders')
    },
    {
      id: 'payment-methods',
      title: t('paymentMethods'),
      icon: 'ri-bank-card-line',
      action: () => navigate('/profile/payment')
    },
    {
      id: 'notifications',
      title: 'الإشعارات',
      icon: 'ri-notification-line',
      action: () => setNotifications(!notifications),
      toggle: true,
      value: notifications
    },
    {
      id: 'language',
      title: 'اللغة',
      icon: 'ri-global-line',
      action: toggleLanguage,
      subtitle: i18n.language === 'ar' ? 'العربية' : 'English'
    },
    {
      id: 'dark-mode',
      title: t('darkMode'),
      icon: 'ri-moon-line',
      action: () => setDarkMode(!darkMode),
      toggle: true,
      value: darkMode
    },
    {
      id: 'support',
      title: 'الدعم الفني',
      icon: 'ri-customer-service-line',
      action: () => navigate('/support')
    },
    {
      id: 'about',
      title: 'حول التطبيق',
      icon: 'ri-information-line',
      action: () => navigate('/about')
    }
  ];

  return (
    <div className="min-h-screen bg-[#FDFDFD] pb-20">
      <TopNavigation title={t('profile')} />
      
      <div className="pt-20 px-4">
        {/* Profile Header */}
        <div className="bg-gradient-to-r from-[#0056A6] to-[#0066CC] rounded-2xl p-6 mb-6 text-white">
          <div className="flex items-center mb-4">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mr-4">
              <i className="ri-user-fill text-white text-2xl"></i>
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-bold mb-1">{userInfo.name}</h2>
              <p className="text-white/80 text-sm">{userInfo.phone}</p>
              <p className="text-white/80 text-sm">{userInfo.email}</p>
            </div>
          </div>
          
          {/* Stats */}
          <div className="grid grid-cols-3 gap-4 pt-4 border-t border-white/20">
            <div className="text-center">
              <p className="text-2xl font-bold">{userInfo.totalTrips}</p>
              <p className="text-white/80 text-xs">رحلة</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-bold">{userInfo.rating}</p>
              <p className="text-white/80 text-xs">التقييم</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-bold">{userInfo.joinDate}</p>
              <p className="text-white/80 text-xs">عضو منذ</p>
            </div>
          </div>
        </div>

        {/* Menu Items */}
        <div className="space-y-2">
          {menuItems.map((item) => (
            <div
              key={item.id}
              onClick={item.action}
              className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 cursor-pointer card-hover transition-all duration-200"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center mr-3">
                    <i className={`${item.icon} text-gray-600 text-lg`}></i>
                  </div>
                  <div>
                    <p className="text-gray-800 font-medium">{item.title}</p>
                    {item.subtitle && (
                      <p className="text-gray-500 text-sm">{item.subtitle}</p>
                    )}
                  </div>
                </div>
                
                {item.toggle ? (
                  <div className="relative">
                    <input
                      type="checkbox"
                      checked={item.value}
                      onChange={() => {}}
                      className="sr-only"
                    />
                    <div className={`w-12 h-6 rounded-full transition-colors duration-200 ${
                      item.value ? 'bg-[#0056A6]' : 'bg-gray-300'
                    }`}>
                      <div className={`w-5 h-5 bg-white rounded-full shadow-md transform transition-transform duration-200 ${
                        item.value ? 'translate-x-6' : 'translate-x-0.5'
                      } translate-y-0.5`}></div>
                    </div>
                  </div>
                ) : (
                  <i className="ri-arrow-left-s-line text-gray-400 text-xl"></i>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Logout Button */}
        <div className="mt-8">
          <button
            onClick={handleLogout}
            className="w-full bg-red-50 text-red-600 py-4 rounded-xl font-medium btn-hover transition-all duration-200"
          >
            <i className="ri-logout-box-line mr-2"></i>
            {t('logout')}
          </button>
        </div>

        {/* App Version */}
        <div className="text-center mt-6 pb-4">
          <p className="text-gray-400 text-sm">MovePro v1.0.0</p>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
}
